const setLocalstorageField = (fieldName: string, value: any) => {
  localStorage.setItem(fieldName, value)
}

export default setLocalstorageField
